var FcCustomBadgeModule = /** @class */ (function () {
    function FcCustomBadgeModule() {
    }
    return FcCustomBadgeModule;
}());
export { FcCustomBadgeModule };
